var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCalendarLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 0.666656V1.99999H9.99967V0.666656H11.333V1.99999H13.9997C14.3679 1.99999 14.6663 2.29847 14.6663 2.66666V13.3333C14.6663 13.7015 14.3679 14 13.9997 14H1.99967C1.63149 14 1.33301 13.7015 1.33301 13.3333V2.66666C1.33301 2.29847 1.63149 1.99999 1.99967 1.99999H4.66634V0.666656H5.99967ZM13.333 7.33332H2.66634V12.6667H13.333V7.33332ZM4.66634 3.33332H2.66634V5.99999H13.333V3.33332H11.333V4.66666H9.99967V3.33332H5.99967V4.66666H4.66634V3.33332Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendarLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar-line.8f8f5a7f.svg";
export { ForwardRef as ReactComponent };